module.exports = __webpack_public_path__ + "resources/img/img_dvision5_m.d7d7859482c11e74f009e73106d166ec.png";